const DashboardActionTypes = {
  GET_DASHBOARD: "GET_DASHBOARD",
  GET_BAR_DASHBOARD: "GET_BAR_DASHBOARD",
};

export default DashboardActionTypes;
